import { Config } from 'olympe';

export const getUserName = async (
  email,
  graphToken,
  showDisplayName = true
) => {
  // Use Or to filter all emails(BP, PM etc.)
  const url =
    Config.getParameter('ms_graph_path') + `/users?$filter=mail eq '${email}'`;
  try {
    const result = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${graphToken}`,
      },
    });
    let fullName;
    if (!result.ok) {
      return {
        error: true,
        message: `Error ${result.status}`,
      };
    } else {
      const jsonResult = await result.json();

      const details = jsonResult.value[0];
      fullName = showDisplayName
        ? details?.displayName
          ? `${details.displayName};${email}`
          : null
        : details?.givenName && details?.surname
          ? `${details.givenName} ${details.surname};${email}`
          : null;
    }
    return fullName;
  } catch (error) {
    return {
      error: true,
      message: error.message,
    };
  }
};

export const getUserNameForStakeHolders = async (
  bpEmail,
  buyerEmail,
  requestorEmail,
  agEmail,
  qaInFactoryEmail,
  sqaEmail,
  psEmail,
  graphToken,
  showDisplayName = true
) => {
  // Use Or to filter all emails(BP, PM etc.)

  const url =
    Config.getParameter('ms_graph_path') + `/users?$filter=mail in ('${bpEmail || ""}', '${buyerEmail || ""}', '${requestorEmail || ""}', '${agEmail || ""}', '${qaInFactoryEmail || ""}', '${sqaEmail || ""}','${psEmail || ""}')`;
  try {
    const result = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${graphToken}`,
      },
    });
    let bpUserObject, buyerUserObject, requestorUserObject,
      agUserObject, qaInFactoryUserObject, sqaUserObject,psUserObject;
    if (!result.ok) {
      return {
        error: true,
        message: `Error ${result.status}`,
      };
    } else {
      const jsonResult = await result.json();

      const userArray = jsonResult.value
      bpUserObject = bpEmail && userArray.filter((user) => (user.mail?.toLowerCase() === bpEmail?.toLowerCase()))
      buyerUserObject = buyerEmail && userArray.filter((user) => user.mail?.toLowerCase() === buyerEmail?.toLowerCase())
      requestorUserObject = requestorEmail && userArray.filter((user) => user.mail?.toLowerCase() === requestorEmail?.toLowerCase())
      agUserObject = agEmail && userArray.filter((user) => user.mail?.toLowerCase() === agEmail?.toLowerCase())
      qaInFactoryUserObject = qaInFactoryEmail && userArray.filter((user) => user.mail?.toLowerCase() === qaInFactoryEmail?.toLowerCase())
      sqaUserObject = sqaEmail && userArray.filter((user) => user.mail?.toLowerCase() === sqaEmail?.toLowerCase())
      psUserObject = psEmail && userArray.filter((user) => user.mail?.toLowerCase() === psEmail?.toLowerCase())

      if ((bpEmail && isArrayBlank(bpUserObject)) ||
        (buyerEmail && isArrayBlank(buyerUserObject)) ||
        (requestorEmail && isArrayBlank(requestorUserObject))
      ) {
        return {
          error: true,
          message: "Any of the stakeholders is not valid",
        };
      } else {
        return [bpUserObject, buyerUserObject, requestorUserObject, agUserObject,
          qaInFactoryUserObject, sqaUserObject,psUserObject];
      }
    }

  } catch (error) {
    return {
      error: true,
      message: error.message,
    };
  }
};

export const isArrayBlank = (arrays) => {
  const isEmpty = arrays.length === 0;
  return isEmpty
}
export const getFullName = (user, showDisplayName = true) => {
  // Logic : if given name and
  const fullName = showDisplayName
    ? user?.displayName
      ? `${user.displayName};${user.mail}`
      : null
    : user?.givenName && user?.surname
      ? `${user.givenName} ${user.surname};${user.mail}`
      : null;
  return fullName;
}
// This function adds the required no of zeros to make this 18 digits long
export const zeroPad = (num) => {
  return num.toString().padStart(18, '0');
};
// This function adds the required no of zeros to make this 4 digits long
export const zero4LeftPad = (num) => {
  return num.toString().padStart(4, '0');
};

// This function adds the required no of zeros to make this 10 digits long
export const padLeftWithZerosFinalDigits = (num, index) => {
  return num?.toString().padStart(index, '0');
};


export const TARGET_BCP_REVERSE_MAP = {
  ["Alternate site with new Vendor"]: "alternateSiteNewVendor",
  ["Alternative site with new Vendor already approved in other plants"]: "alternativeSiteApprovedPlant",
  ["Alternate site with same Vendor"]: "alternateSiteSameVendor"
}

export const isNumeric = (num) => {
  return !isNaN(parseFloat(num)) && isFinite(num);
};

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

// Composite key generator function
export const getKey = (obj) =>
  `${obj.plant}-${obj.material}-${obj.specification}`;


  export const removeZeros = (num) => {
    return num.replace(/^0+/, '');
};